<script>
import {
    modalState, hideModal, showModal
} from '@app/store/modalStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    historyState, insertHistoryAction, resetHistory
} from '@app/store/historyStore.svelte.js';
import {
    fade
} from 'svelte/transition';
import * as m from '@app/paraglide/messages.js';
let insertOption = $state("single");

function insertMusicNotes() {
    let insertChar,
        alignmentMap = {
            left: false,
            right: "right",
            center: "center"
        };
    if (insertOption === "single" || insertOption === "singleSurround") {
        insertChar = "♪";
    } else {
        insertChar = "♪♪";
    }

    eventGroupState[projectState.selected].selected.forEach((eventIndex, count) => {
        let startIndex = eventGroupState[projectState.selected].events[eventIndex].text.indexOf(">") + 1;

        eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.substring(0, startIndex) + insertChar + 
        " " + eventGroupState[projectState.selected].events[eventIndex].text.substring(startIndex);

        if (insertOption === "singleSurround" || insertOption === "doubleSurround") {
            let endIndex = eventGroupState[projectState.selected].events[eventIndex].text.lastIndexOf("<");

            eventGroupState[projectState.selected].events[eventIndex].text = eventGroupState[projectState.selected].events[eventIndex].text.substring(0, endIndex) + " " + insertChar + eventGroupState[projectState.selected].events[eventIndex].text.substring(endIndex);
        }

        if (count === 0 && window.quillEditor) {
            let delta = window.quillEditor.clipboard.convert({ html: eventGroupState[projectState.selected].events[eventIndex].text });
            window.quillEditor.setContents(delta, "silent");
            window.quillEditor.formatLine(0,9999, 'align', eventGroupState[projectState.selected].events[eventIndex].alignment === 'left' ? '' : eventGroupState[projectState.selected].events[eventIndex].alignment, "silent");
        }
    });
    
    insertHistoryAction({
        name: "insert music notes", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });

    hideModal();
}
</script>

<div transition:fade={{duration: 100}} 
    class="modal {modalState.selected === 'musicNotes' ? 'show d-block' : ''}" 
    role="dialog" 
    aria-labelledby="musicNotesTitle"
    aria-describedby="musicNotesDesc"
    tabindex="-1" 
    id="MusicNotesModal">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="musicNotesTitle">{m.insert_music_notes_title()}</h4>
                <button type="button" 
                    class="btn-close" 
                    id="btnCloseMusicNotes"
                    aria-label={m.close_dialog()} 
                    onclick={hideModal}></button>
            </div>
            <div class="modal-body">
                <p id="musicNotesDesc" class="sr-only">{m.music_notes_description()}</p>
                <form>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" id="musicNotesSingle" bind:group={insertOption} name="insertOption" value={"single"}>
                        <label class="form-check-label" for="musicNotesSingle">{m.music_notes_single()}</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" id="musicNotesDouble" bind:group={insertOption} name="insertOption" value={"double"}>
                        <label class="form-check-label" for="musicNotesDouble">{m.music_notes_double()}</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" id="musicNotesSurround" bind:group={insertOption} name="insertOption" value={"singleSurround"}>
                        <label class="form-check-label" for="musicNotesSurround">{m.music_notes_surround_single()}</label>
                    </div>
                    <div class="form-check">
                        <input class="form-check-input" type="radio" id="musicNotesDoubleSurround" bind:group={insertOption} name="insertOption" value={"doubleSurround"}>
                        <label class="form-check-label" for="musicNotesDoubleSurround">{m.music_notes_surround_double()}</label>
                    </div>
                    <button class="btn btn-primary float-end" 
                        type="button"
                        id="btnInsertMusicNotes"
                        aria-label={m.insert_music_notes()} 
                        onclick={insertMusicNotes}>{m.insert()}</button>
                </form>
            </div>
        </div>
    </div>
</div>
